import Loadable from "react-loadable";
import Loader from "components/shared/loader/loader";
import { IRoute } from "shared/interface/types";

const parentBreadCrumbs = [
  { title: "menu_sidebar_management" },
  { title: "menu_sidebar_management_list_management" },
  { title: "menu_sidebar_management_exclusion" }
];

const ExclusionsListing = Loadable({
  loader: () => import("container/management/exclusions"),
  loading() {
    return <Loader />;
  }
});

export const exclusionRoutes: IRoute[] = [
  {
    path: "/management/exclusions",
    element: <ExclusionsListing />,
    handle: {
      crumbs: parentBreadCrumbs
    }
  }
];
